import apiClient from './apiClient';

export interface ApprovalCandidate {
  fj190_01: string; // 繳庫單號
  fj190_11: string; // 繳庫日期
  fj190_12: string; // 庫別名稱
  fj190_23: string; // 入單人員名稱
  fj190_80: string; // 核准狀態
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

export const pwj508Api = {
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwj508/candidates', { params });
    return res.data;
  },

  async approve(items: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwj508/approve', { items });
    return res.data;
  },
};
